import React from "react";
import { MessageCircle, Info } from "lucide-react";
import { ASK_RENN } from "../mock";
import Reveal from "./Reveal";

const AskRenn = () => {
  return (
    <section id="ask-renn" className="relative py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-start">
        <Reveal>
          <p className="text-[13px] font-semibold tracking-wide text-[#13D99A] uppercase mb-4">Ask Renn</p>
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#F5F7FB] leading-[1.08]">
            {ASK_RENN.headline}
          </h2>
          <p className="mt-5 text-lg text-[#8290A8] leading-relaxed">{ASK_RENN.copy}</p>
          <p className="mt-6 text-[#F5F7FB] font-medium">{ASK_RENN.note}</p>
          <div className="mt-6 flex items-start gap-3 rounded-xl border border-[#29354A] bg-[#121A28] p-4 text-sm text-[#8290A8]">
            <Info className="w-5 h-5 text-[#10C98A] shrink-0 mt-0.5" />
            <span>{ASK_RENN.disclaimer}</span>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <div className="rounded-2xl border border-[#29354A] bg-[#121A28] overflow-hidden">
            <div className="flex items-center gap-2 px-5 py-4 border-b border-[#29354A] bg-[#0A1220]">
              <span className="w-8 h-8 rounded-full bg-[#10C98A]/15 flex items-center justify-center">
                <MessageCircle className="w-4 h-4 text-[#13D99A]" />
              </span>
              <span className="font-display font-semibold text-[#F5F7FB]">Ask Renn</span>
            </div>
            <div className="p-5">
              <p className="text-xs uppercase tracking-wide text-[#8290A8] mb-3">Try asking</p>
              <div className="flex flex-col gap-2.5">
                {ASK_RENN.questions.map((q) => (
                  <button
                    key={q}
                    className="text-left text-sm text-[#F5F7FB] rounded-xl border border-[#29354A] bg-[#0A1220] px-4 py-3 hover:border-[#10C98A]/50 hover:bg-[#172031] transition-colors"
                  >
                    {q}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default AskRenn;
